<template>
  <!--待办列表-->
  <List v-if="status == 0" @toCreate="toCreate"></List>
  <!--新建待办-->
  <ToCreate
    v-if="status == 1"
    @back="backto0()"
    @success="successTo0"
  ></ToCreate>
</template>

<script>
import List from "@/components/personalCenter/todo/list.vue";
import ToCreate from "@/components/personalCenter/todo/toCreate.vue";
export default {
  name: "ToDoList",
  props: [],
  components: {
    List,
    ToCreate,
  },
  data() {
    return {
      status: 0, //0 列表 1新建  2查看
    };
  },
  methods: {
    toCreate() {
      let that = this;
      that.status = 1;
    },
    backto0() {
      let that = this;
      that.status = 0;
    },
    successTo0() {
      let that = this;
      that.status = 0;
    },
  },
};
</script>

<style lang="scss" scoped></style>
